import { Field, Form } from "react-final-form";
import React, { Component } from "react";

import Button from "react-bootstrap/Button";
import FormInput from "../../Components/FormInput/FormInput";
import LoadingIcon from "../../Components/LoadingIcon";
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "./styles";
import { withStyles } from "@material-ui/styles";

const ConfirmAccountDeletion = props => {
  return (
    <SweetAlert
      danger
      showCancel
      confirmBtnText="Yes"
      cancelBtnText="No"
      confirmBtnBsStyle="danger"
      cancelBtnBsStyle="primary"
      title="Delete Account?"
      onConfirm={props.onDelete}
      onCancel={props.handleDeleteConfirm}
    >
      Are you sure you want to delete this account?
    </SweetAlert>
  );
};

class GeneralSettingsForm extends Component {
  state = {
    show: false,
    deleteConfirm: false,
    error: this.props.generalSettingsError,
    success: this.props.generalSettingsSuccess,
    fetching: this.props.fetching,
  };

  componentDidMount(){
    this.setState({
      error: this.props.generalSettingsError,
      success: this.props.generalSettingsSuccess,
      fetching: this.props.fetching,
    })
  }

  _onDelete = () => {
    this.setState({
      show: !this.state.show
    });
  };

  handleDeleteConfirm = () => {
    this.setState({
      deleteConfirm: !this.state.deleteConfirm
    });
  };

  render() {
    const {
      handleSubmit,
      email,
      firstName,
      // lastName,
      classes,
    } = this.props;
    const { deleteConfirm, fetching, error, success } = this.state;
    return (
      <div
        className={`
          ${classes.settings} ${error &&
          classes.settingsError} ${success &&
          classes.settingsSuccess}`}
      >
        <Form onSubmit={handleSubmit}>
          {({ handleSubmit }) => (
            <form className={classes.formContainer} onSubmit={handleSubmit}>
              <div className={classes.container}>
                <div className={classes.textContainer}>
                  <div className={classes.formInput}>
                    <label className={classes.label}>Username</label>
                    <div className={classes.field}>
                      <Field
                        name={"email"}
                        component={FormInput}
                        placeholder={email}
                      />
                    </div>
                  </div>
                  <div className={classes.formInput}>
                    <label className={classes.label}>Display Name</label>
                    <div className={classes.field}>
                      <Field
                        name={"firstName"}
                        component={FormInput}
                        placeholder={firstName}
                      />
                    </div>
                  </div>
                  {/* <div className={classes.formInput}>
                    <label className={classes.label}>Last Name</label>
                    <div className={classes.field}>
                      <Field
                        name={"lastName"}
                        component={FormInput}
                        placeholder={lastName}
                      />
                    </div>
                  </div> */}
                </div>
                <div className={classes.formResultsContainer}></div>
              </div>
              <div className={classes.buttons}>
                {deleteConfirm ? (
                  <ConfirmAccountDeletion
                    handleDeleteConfirm={this.handleDeleteConfirm}
                    onDelete={this.handleDeleteAccount}
                  />
                ) : null}
                <Button type="submit">
                  Save {fetching && <LoadingIcon />}
                </Button>
              </div>
              {success && (
                <div className={classes.successContainer}>
                  <p className={classes.successText}>Settings updated</p>
                </div>
              )}
              {error && (
                <div className={classes.errorContainer}>
                  <p className={classes.errorText}>
                    There was an error with updating the settings
                  </p>
                </div>
              )}
            </form>
          )}
        </Form>
      </div>
    );
  }
}

export default withStyles(styles)(GeneralSettingsForm);
